<template>
  <el-dialog title="应用提示" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="dialog_conwrap">
      <p>应用默认内容有两种装修方案，请慎重选择</p>
      <p>全页面替换：替换后，员工名片页展示内容与默认内容一致， 员工原有名片内容将被替换</p>
      <p>缺失内容补充：仅对员工未填写的内容进行补充， 员工原有名片内容不受任何影响</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">全页面替换</el-button>
      <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: "applicationHintsDialog",
  props: ["visible"],
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  },
  data() {
    return {
      dialogVisible: this.visible
    };
  }
};
</script>

